export default {"src":"/_next/static/media/CSX.36b1167e.svg","height":18,"width":18};